<app-navbar
  [title]="this.products?.planName"
  [backLink]="'/I4UProducts'"
  [showBackButton]="true"
  [showLogout]="true"
>
</app-navbar>

<div class="body">

  <!-- ═══ Hero: the selling facts, visible without scrolling (replaces the banner slider) ═══ -->
  <section class="plan-hero">
    <h1 class="hero-name">{{ this.products?.planName }}</h1>
    <div class="hero-facts">
      @if (heroCoverageMax > 0) {
        <div class="hero-fact">
          <span class="hero-fact-label">{{ 'PRODUCT_PLAN_DETAIL.HERO_COVERAGE' | translate }}</span>
          <span class="hero-fact-value">{{ heroCoverageMax | number }} <small>₭</small></span>
        </div>
      }
      @if (heroPerDay > 0) {
        <div class="hero-fact">
          <span class="hero-fact-label">{{ 'PRODUCT_LIST.FROM_ONLY' | translate }}</span>
          <span class="hero-fact-value accent">{{ heroPerDay | number }} <small>{{ 'PRODUCT_LIST.KIP_PER_DAY' | translate }}</small></span>
        </div>
      }
    </div>
    <button matButton="filled" class="hero-calc-btn" (click)="scrollToCalc()">
      <i class="fa-solid fa-calculator"></i> {{ 'PRODUCT_PLAN_DETAIL.CALC_PROMPT_BTN' | translate }}
    </button>
  </section>

  <!-- ═══ Key facts strip (merged: suitable-for / covered / age / period) ═══ -->
  <section class="section-plan-detail">
    <div class="key-facts width-box">
      <div class="key-fact">
        <h6><i class="fa-solid fa-user-check"></i> {{ 'PRODUCT_PLAN_DETAIL.SUITABLE_FOR' | translate }}</h6>
        <p>{{ this.products?.bestFor }}</p>
      </div>
      <div class="key-fact">
        <h6><i class="fa-solid fa-user-shield"></i> {{ 'PRODUCT_PLAN_DETAIL.WHAT_IS_COVERED' | translate }}</h6>
        <p>{{ this.products?.coverageDesc }}</p>
      </div>
      <div class="key-fact">
        <h6><i class="fa-solid fa-cake-candles"></i> {{ 'PRODUCT_PLAN_DETAIL.COVERAGE_AGE' | translate }}</h6>
        <p>
          @if(this.plan?.minAge <= 0 && this.plan?.maxAge >= 99){ {{ 'PRODUCT_PLAN_DETAIL.NO_AGE_LIMIT' | translate }} }
          @else { {{ this.products?.ageCoverage || '-----' }} }
        </p>
      </div>
      <div class="key-fact">
        <h6><i class="fa-solid fa-calendar-days"></i> {{ 'PRODUCT_PLAN_DETAIL.COVERAGE_PERIOD' | translate }}</h6>
        <p>
          @if(this.products?.coverageYear > 0){ {{ this.products?.coverageYear }} {{ 'PRODUCT_PLAN_DETAIL.YEARS' | translate }} }
          @else if(!this.products?.coverageYear){ {{ 'PRODUCT_PLAN_DETAIL.LIFETIME' | translate }} }
          @else { ----- }
          @if(this.products?.paymentYear < this.products?.coverageYear){
            ({{ 'PRODUCT_PLAN_DETAIL.PAY_ONLY' | translate }} {{ this.products?.paymentYear }} {{ 'PRODUCT_PLAN_DETAIL.YEARS' | translate }})
          }
        </p>
      </div>
      <div class="key-fact key-fact-wide">
        <h6><i class="fa-solid fa-sack-dollar"></i> {{ 'PRODUCT_PLAN_DETAIL.PAYMENT_METHOD' | translate }}</h6>
        <div class="term-chips">
          @for (paymentTerm of this.products?.paymentTerms; track paymentTerm.term) {
            <span class="term-chip">{{ paymentTerm.term }}</span>
          }
        </div>
      </div>
    </div>
  </section>

  <!-- ═══ Benefits — open list, no accordion chrome ═══ -->
  <section class="section-plan-detail">
    <h1>{{ 'PRODUCT_PLAN_DETAIL.BENEFITS_YOU_GET' | translate }}</h1>
    <div class="benefits-card width-box">
      <ol class="benefits-list">
                <li *ngFor="let productCoverage of this.products?.productCoverages">
                  {{ productCoverage.name }}
                </li>
              </ol>
    </div>
  </section>

  <!-- ═══ Calculator — inline, single scroll to decision ═══ -->
  <section class="section-plan-detail" id="premium-calculator">
    <h1>{{ 'PRODUCT_PLAN_DETAIL.TAB_CALCULATE_PREMIUM' | translate }}</h1>
    <div class="width-box calculator-container">
      <div class="width-box calculator-container">
        <div class="row mb-3 mt-3">
          <!-- Age input -->
          <div class="col-sm-6">
            <label class="mb-2 la-font">{{ 'PRODUCT_PLAN_DETAIL.INSURED_AGE' | translate }}<span class="form-required">*</span></label>
            <mat-form-field appearance="outline" class="form-field-full-width">
              <input matInput type="number" [(ngModel)]="insuredAge" min="1" max="99"
                     placeholder="1-99" />
            </mat-form-field>
          </div>

          <div class="col-sm-6" *ngIf="!shouldHideCoverageAmount">
            <label class="mb-2 la-font">{{ 'PRODUCT_PLAN_DETAIL.COVERAGE_AMOUNT' | translate }}<span class="form-required">*</span></label>

            <mat-form-field appearance="outline" class="form-field-full-width">
              <mat-select
                [value]="this.productOptions[0]?.id"
                (selectionChange)="handleProductOptionChange($event.value)"
              >
                <mat-option *ngFor="let option of productOptions" [value]="option.id">
                  {{ option.amount | number }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="{{ !shouldHideCoverageAmount ? 'col-sm-12' : 'col-sm-6' }}">
            <label class="mb-2 la-font">{{ 'PRODUCT_PLAN_DETAIL.PAYMENT_PERIOD' | translate }}<span class="form-required">*</span></label>
            <mat-form-field appearance="outline" class="form-field-full-width">
              <mat-select
                [value]="this.paymentTerms[0]?.termId"
                (selectionChange)="handleProductTermChange($event.value)"
              >
                <mat-option *ngFor="let term of paymentTerms" [value]="term.termId">
                  {{ term.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <section class="section-plan-detail">
          <div class="big-card width-box">
            <div class="mini-card third">
              <div class="box">
                <h6>{{ 'PRODUCT_PLAN_DETAIL.PREMIUM_PER_PERIOD' | translate }}</h6>
                <div class="content">
                  <span class="currency-symbol">₭</span>
                  <h4>{{ this?.updatePremiumAmtPerTime | number }}</h4>
                </div>
              </div>
              <div class="box">
                <h6>{{ 'PRODUCT_PLAN_DETAIL.PREMIUM_PER_YEAR' | translate }}</h6>
                <div class="content">
                  <span class="currency-symbol">₭</span>
                  <h4>{{ this?.updatePremiumAmtPerYear | number }}</h4>
                </div>
              </div>

              <div class="box">
                <h6 class="total-premium-label">{{ 'PRODUCT_PLAN_DETAIL.TOTAL_PREMIUM_AMOUNT' | translate }}</h6>
                <div class="content">
                  <span class="currency-symbol">₭</span>
                  <h4 class="total-premium-amount">{{ this?.updateTotalPremiumAmt | number }}</h4>
                </div>
              </div>
            </div>
          </div>

          <div class="apply-cta width-box">
            <button
              matButton="filled"
              class="primary-bg-color"
              [routerLink]="['/application-create']"
              [queryParams]="{ productId: productId, planId: planId, termId: selectedTermId, coverageAmt: selectedCoverageAmtValue, age: insuredAge }">
              <i class="fa-solid fa-file-signature"></i>
              {{ 'PRODUCT_PLAN_DETAIL.APPLY_WITH_PLAN' | translate }}
            </button>
          </div>
        </section>
      </div>
      </div>
  </section>
</div>
